import styled from 'styled-components'

import {Breadcrumb, Button, Layout as AntLayout, Steps} from 'antd';

interface HeaderProps {
    headercolor: string,
}

interface BreadcrumbProps {
    bordercolor: string
}

interface StepsProps {
    stepcolor: string
}

interface PageFooterProps {
    fontcolor: string
    footercolor: string
}

interface ButtonProps {
    type: string
    color: string
}

const {Header, Footer, Content} = AntLayout;

export const PageHeader = styled(Header)<HeaderProps>`
  background: ${props => props.headercolor};
`;

export const Logo = styled.img`
  float: left;
  /* width: 120px; */
  height: 31px;
  margin: 16px 24px 16px 0;
`;

export const Container = styled.div`
  background: #fff;
  padding: 24px;
  min-height: 480px;
`;

export const PageContent = styled(Content)`
  padding: 0px 10px;
  background: #f1f1f1;
`

export const PageFooter = styled(Footer)<PageFooterProps>`
  background: ${props => props.footercolor};
  text-align: center;
  color: ${props => props.fontcolor};
  font-size: 16px;
`

export const ContainerStep = styled.div`
  padding: 20px;
`

export const StepsBody = styled.div`
  min-height: 200px;
  margin-top: 16px;
  padding-top: 80px;
  text-align: center;
  background-color: #fafafa;
  border: 1px dashed #e9e9e9;
  border-radius: 2px;
`;

export const Title = styled(Breadcrumb)<BreadcrumbProps>`
  margin: 16px 0;
  margin-bottom: 25px;
  padding-bottom: 10px;
  font-size: 20px;
  border-bottom: 2px solid ${props => props.bordercolor};
`;

export const ScheduleStep = styled(Steps)<StepsProps>`
  .ant-steps-item-process > .ant-steps-item-container {
    .ant-steps-item-icon {
      background: ${props => props.stepcolor};
      border-color: ${props => props.stepcolor};

      .ant-steps-icon > span {
        color: ${props => props.stepcolor};
      }
    }

    .ant-steps-item-content > .ant-steps-item-title::after {
      background-color: ${props => props.stepcolor};
    }
  }

  .ant-steps-item-finish > .ant-steps-item-container {
    .ant-steps-item-icon {
      background: ${props => props.stepcolor};
      border-color: ${props => props.stepcolor};
    }

    .ant-steps-item-content > .ant-steps-item-title::after {
      background-color: ${props => props.stepcolor};
    }
  }

  .ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: #fff;
    border-color: #24695c;
  }

  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: ${props => props.stepcolor};
  }
`

export const AppButton = styled(Button)<ButtonProps>`
  color: #fff !important;
  border-color: transparent !important;
  background: red;

  :hover {
    color: #fff !important;
    border-color: transparent !important;
    background: #DC3644;
  }

  :focus {
    color: #fff !important;
    border-color: transparent !important;
    background: #DC3644;
  }
`
